import {useState} from 'react';

import {useDeleteRecordMutation} from './useRecordMutations';
import {useDnsRecordsSelection} from './useDnsRecordsSelection';
import {DnsRecord} from '../types';

// FNP-1192 — the delete flow: request, confirm, clear.
//
// Holds the record under confirmation so the modal can name it, and clears the
// selection after a successful delete (the DELETE pattern doc's last step) —
// leaving a deleted row ticked would carry a phantom selection into the next
// action.
export const useRecordDeletion = (connectionId?: string, zoneId?: string) => {

    const [record, setRecord] = useState<DnsRecord | undefined>(undefined);
    const [opened, setOpened] = useState(false);

    const {clearSelection} = useDnsRecordsSelection();
    const deleteMutation = useDeleteRecordMutation(connectionId, zoneId);

    const requestDelete = (next: DnsRecord) => {
        // The previous attempt's error must not greet the next confirmation.
        deleteMutation.reset();
        setRecord(next);
        setOpened(true);
    };

    const cancelDelete = () => {
        setOpened(false);
        setRecord(undefined);
        deleteMutation.reset();
    };

    const confirmDelete = () => {
        if (!record) {
            return;
        }
        deleteMutation.mutate(record, {
            // ⚠️ THE MODAL CLOSES ONLY ON SUCCESS. A refusal — a read-only
            // credential above all — leaves it open with the classified error
            // rendered inline, because a toast is gone before an operator has
            // finished reading it.
            onSuccess: () => {
                setOpened(false);
                setRecord(undefined);
                clearSelection();
            },
        });
    };

    return {
        record,
        opened,
        requestDelete,
        cancelDelete,
        confirmDelete,
        isDeleting: deleteMutation.isPending,
        error: deleteMutation.error,
    };
};
